module.exports = __webpack_public_path__ + "96361ef479ece685b5e47ab7a7623814.svg";